export default "__VITE_ASSET__uEPQq7mW__"